<template>
    <div class="trips-search home">
    <!-- <div class="trips-search pl-5 min-vh-100" :style="{ 'background-image': data.length === 0 ? 'url(https://d36xws8ymuqmas.cloudfront.net/illustrations/abstract/' + (Math.floor(Math.random()*(9-1+1)+1)) + '.jpg?width=1400&height=500)' : null }"> -->
        <div class="heading">
            <div class="container-fluid">
                <h1>
                    {{ 'search.home.heading1' | trans }}<br />
                    {{ 'search.home.heading2' | trans }}
                </h1>
                <p class="lead">
                    {{ 'search.home.subheading' | trans }}
                </p>

                <!-- Property scope -->
                <!-- <div class="property-scope">
                    <button type="button" class="btn" :class="{ active: filters.property_scope === 'hotels' }" @click="setPropertyScope('hotels')">
                        <i class="fa fa-hotel mr-1"></i>
                        Hotel
                    </button>

                    <button type="button" class="btn" :class="{ active: filters.property_scope === 'homes' }" @click="setPropertyScope('homes')">
                        <i class="fa fa-house mr-1"></i>
                        Ferienwohnung
                    </button>
                </div> -->
            </div>
        </div>

        <div class="nav-container">
            <div class="container-fluid">
                <h2>
                    {{ 'search.home.search' | trans }}
                </h2>
                <!-- Search tabs -->
                <!-- <div class="search-tabs" v-if="! currentSearch">
                    <button class="btn btn-link btn-sm" v-for="tab in tabs" :class="{ 'text-dark': tab === currentTab, 'text-muted': tab !== currentTab }" @click="currentTab = tab">
                        {{ 'search.tabs.' + tab | trans }}
                    </button>
                </div> -->

                <!-- Create search -->
                <nav class="search-navbar">
                    <!-- Query -->
                    <LocationInput
                    v-model="query"
                    :location="location"
                    @changeLocation="handleChangeLocation"
                    :inline="currentSearch !== null"
                    ref="locationInput" />

                    <!-- Travel period -->
                    <TravelPeriodPicker
                    :origin-period="travelPeriod"
                    @changeTravelPeriod="handleChangeTravelPeriod"
                    :inline="currentSearch !== null"
                    ref="travelPeriodPicker" />

                    <!-- Persons picker -->
                    <PersonsPicker
                    :origin-persons="persons"
                    @changePersons="handleChangePersons"
                    :inline="currentSearch !== null"
                    ref="personsPicker" />

                    <!-- Search button -->
                    <button type="button" class="btn btn-primary btn-lg search-button" @click="() => search()">
                        <span v-if="! isLoading">
                            <i class="wa-icon-search"></i>
                        </span>
                        <span v-if="! isLoading" class="d-md-none d-lg-inline-block ml-1">
                            {{ 'search.home.search' | trans }}
                        </span>

                        <svg class="white-loader" viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg" v-if="isLoading">
                            <circle class="internal-circle" cx="60" cy="60" r="30"></circle>
                            <circle class="external-circle" cx="60" cy="60" r="50"></circle>
                        </svg>
                    </button>
                </nav>
            </div>
        </div>

        <!-- Home -->
        <!-- container-overflow-right -->
        <div class="search-home" v-if="homeData && homeData.collections">
            <div class="container-fluid" v-for="(collection, collectionIndex) in homeData.collections">
                <div class="divider" v-if="collectionIndex !== 0"></div>

                <div class="collection" :class="['collection-type--' + collection.type]">
                    <h2>
                        {{ collection.name }}
                    </h2>

                    <div class="items-container row">
                        <div class="mb-3" :class="{ 'col-lg-3 col-md-4 col-sm-6 col-6': collection.type !== 'search', 'col-lg-3 col-md-4 col-sm-6 col-12': collection.type === 'search' }" v-for="item in collection.items">
                            <!-- Item -->
                            <SearchCard :item="item" v-if="collection.type === 'search'" @click="selectSearch(item)" />
                            <RegionCard :item="item" v-if="collection.type === 'region'" @click="selectRegion" />
                            <TransferTypeCard :item="item" v-if="collection.type === 'transfer_type'" />
                            <PropertyTypeCard :item="item" v-if="collection.type === 'property_type'" @click="selectPropertyType(item)" />
                            <PropertyThemeCard :item="item" v-if="collection.type === 'property_theme'" />
                            <DisplayPromoCard :item="item" v-if="collection.type === 'display_promo'" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Loader -->
        <div class="container py-5 text-center" v-if="isLoading && (! homeData || data.length === 0)">
            <svg class="loader" viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
                <circle class="internal-circle" cx="60" cy="60" r="30"></circle>
                <circle class="external-circle" cx="60" cy="60" r="50"></circle>
            </svg>
        </div>
    </div>
</template>

<script>
    import LocationInput from './search/LocationInput.vue'
    import TravelPeriodPicker from './search/TravelPeriodPicker.vue'
    import PersonsPicker from './search/PersonsPicker.vue'
    import PropertyList from './search/PropertyList.vue'
    import Map from './search/Map.vue'
    import Filters from './search/Filters.vue'
    import LoadingPlaceholder from './search/LoadingPlaceholder.vue'
    import EmptyMessage from './search/EmptyMessage.vue'

    // Item cards
    import SearchCard from './search/itemCards/Search.vue'
    import RegionCard from './search/itemCards/Region.vue'
    import TransferTypeCard from './search/itemCards/TransferType.vue'
    import PropertyTypeCard from './search/itemCards/PropertyType.vue'
    import PropertyThemeCard from './search/itemCards/PropertyTheme.vue'
    import DisplayPromoCard from './search/itemCards/DisplayPromo.vue'

    export default {
        components: {
            LocationInput,
            TravelPeriodPicker,
            PersonsPicker,
            PropertyList,
            Map,
            Filters,
            LoadingPlaceholder,
            EmptyMessage,

            // Item cards
            SearchCard,
            RegionCard,
            TransferTypeCard,
            PropertyTypeCard,
            PropertyThemeCard,
            DisplayPromoCard,
        },
        props: [],
        data() {
            return {
                tabs: ['create_search', 'saved_searches', 'search_code'],
                currentTab: 'create_search',
                homeData: null,
                currentSearch: null,
                isShowHistory: false,
                isShowFilters: false,
                query: '',
                location: null,
                travelPeriod: null,
                persons: [],
                data: [],
                meta: {},
                currentPage: null,
                centerProperty: null,
                cancelSource: null,
                isLoading: false,
                isCopied: false,
                isMounted: false,
                lastSearch: null,

                // Filters data
                propertyTypes: [],
                additionalFilters: [],

                // Filters
                filters: {
                    is_refundable: false,
                    is_package: false,
                    property_types: [],
                    property_scope: 'hotels',
                    property_stars: [],
                    ratings: null,
                    price_range: [],
                },

                // Order
                order: 'recommended',
            }
        },
        mounted() {
            this.loadHome()
            this.loadCookies()

            this.isMounted = true
        },
        computed: {
            pages() {
                if (this.meta && this.meta.from && this.currentPage) {
                    let pages = []
                    for (var i = this.currentPage; i <= this.meta.last_page; i++) {
                        pages.push(i)
                    }

                    if (this.currentPage === 2) {
                        pages = [1, ...pages]
                    }
                    if (this.currentPage > 2) {
                        pages = [pages[0] - 2, pages[0] - 1, ...pages]
                    }

                    // Slice to max five
                    pages = pages.slice(0, 5)

                    if (pages.length < 5) {
                        for (var i = 0; i <= 5 - pages.length; i++) {
                            pages = [pages[0] - i, ...pages]
                        }
                        pages = pages.sort()
                    }

                    // Filter negative values
                    return [...new Set(pages)].filter((page) => page > 0).sort().slice(0, 5).sort()
                }

                return []
            },

            bookmarkedHotels() {
                if (! this.currentSearch || (this.currentSearch && ! this.currentSearch.bookmarks)) {
                    return []
                }

                return this.currentSearch.bookmarks.map((bookmark) => {
                    bookmark.hotel.is_bookmarked = true

                    return bookmark.hotel
                })
            },

            filtersCount() {
                let count = 0
                
                if (this.filters.is_refundable === false) {
                    count++
                }

                if (this.filters.property_types.length > 0) {
                    count++
                }

                if (this.filters.property_stars.length > 0) {
                    count++
                }

                if (this.filters.ratings !== null) {
                    count++
                }

                if (this.filters.price_range.length > 0) {
                    count++
                }

                return count
            },
        },
        methods: {
            hideDropdowns(exclude) {
                const targets = ['locationInput', 'travelPeriodPicker', 'personsPicker']

                targets.filter((target) => target !== exclude)
                .forEach((target) => {
                    if (this.$refs[target]) this.$refs[target].hideDropdown()
                })
            },
            setPropertyScope(scope) {
                this.filters.property_scope = scope

                if (this.query.trim().length === 0) {
                    $('input#region').focus();
                }

                if (this.query.trim().length > 0 && this.travelPeriod === null && this.$refs.travelPeriodPicker) {
                    this.$refs.travelPeriodPicker.toggleCheckIn()
                }
            },
            handleChangeLocation(location) {
                this.location = location
                this.query = location.name

                // Open travel period picker if none is set
                if (this.travelPeriod === null && this.$refs.travelPeriodPicker) {
                    this.$refs.travelPeriodPicker.toggleCheckIn()
                }

                // Set order
                if (this.location.has_polygon) {
                    this.order = 'recommended';
                } else {
                    this.order = 'distance'
                }
            },
            handleChangeTravelPeriod(period) {
                this.travelPeriod = period
            },
            handleChangePersons(persons) {
                this.persons = persons
            },

            loadHome() {
                var self = this;

                this.isLoading = true

                axios.get(route('api.frontend.search.index'), {}).then(function (response) {
                    self.homeData = response.data.data

                    self.isLoading = false
                }).catch(function (error) {
                    console.log(error);
                    self.isLoading = false
                });
            },

            loadCookies() {
                const hotelInputs = this.$cookies.get('wa_hotel_inputs')
                
                if (hotelInputs === null) {
                    return;
                }

                console.log('Loaded inputs', hotelInputs);

                // Reflect inputs
                if (hotelInputs.location) {
                    this.location = hotelInputs.location
                }
                
                if (hotelInputs.travel_period_from && hotelInputs.travel_period_to) {
                    this.travelPeriod = {
                        from: moment(hotelInputs.travel_period_from),
                        to: moment(hotelInputs.travel_period_to),
                    }
                }

                var persons = [];
                persons.push({
                    type: 'adult',
                    birthdate: '1990-01-01',
                    amount: hotelInputs.adults,
                });

                for (var i = 0; i < hotelInputs.children.length; i++) {
                    persons.push({
                        type: 'child',
                        birthdate: hotelInputs.children[i],
                        amount: 1
                    });
                }
                this.persons = persons

                var self = this
                setTimeout(() => {
                    self.reloadInputs()
                }, 200)
            },

            reloadInputs() {
                if (this.$refs.travelPeriodPicker) {
                    this.$refs.travelPeriodPicker.loadOrigin();
                }

                if (this.$refs.personsPicker) {
                    this.$refs.personsPicker.loadOrigin();
                }
            },

            updateCookies() {
                const hotelInputs = {
                    location: this.location,
                    travel_period_from: this.travelPeriod ? this.travelPeriod.from.format('YYYY-MM-DD') : null,
                    travel_period_to: this.travelPeriod ? this.travelPeriod.to.format('YYYY-MM-DD') : null,
                    adults: this.$lodash.sumBy(this.persons.filter((person) => person.type === 'adult'), 'amount'),
                    children: this.persons.filter((person) => person.type === 'child').map((child) => child.birthdate),
                };

                this.$cookies.set('wa_hotel_inputs', hotelInputs)
            },

            search() {
                var self = this;

                if (! this.location && this.$refs.locationInput) {
                    this.$refs.locationInput.focus()

                    return;
                }

                if (! this.location && ! this.currentSearch) {
                    // Check if home is loaded
                    if (! this.homeData) {
                        this.loadHome()
                    }

                    return;
                }

                // Check if only travel_period_from is set and set departure date one day later
                if (this.travelPeriod && this.travelPeriod.from && ! this.travelPeriod.to) {
                    this.travelPeriod = {
                        from: this.travelPeriod.from,
                        to: this.travelPeriod.from.clone().add(1, 'days'),
                    };
                }

                // Update cookies
                this.updateCookies();

                // Check for hotel redirect
                // if (this.location && this.location.hotel) {
                //     const hotelParams = {
                //         date_from: this.travelPeriod ? this.travelPeriod.from.format('YYYY-MM-DD') : null,
                //         date_to: this.travelPeriod ? this.travelPeriod.to.format('YYYY-MM-DD') : null,
                //         adults: this.$lodash.sumBy(this.persons.filter((person) => person.type === 'adult'), 'amount'),
                //         children: this.persons.filter((person) => person.type === 'child').map((child) => child.birthdate),
                //     };
                //     if (hotelParams.children === null || hotelParams.children.length === 0) {
                //         delete hotelParams.children
                //     }

                //     this.$window.location.href = this.location.hotel.url + '?' + new URLSearchParams(hotelParams).toString();
                    
                //     return;
                // }

                // Check last search
                const params = {
                    region_id: this.location ? parseInt(this.location.id, 10) : null,
                    token: this.currentSearch ? this.currentSearch.token : null,
                    travel_period_from: this.travelPeriod ? this.travelPeriod.from.format('YYYY-MM-DD') : null,
                    travel_period_to: this.travelPeriod ? this.travelPeriod.to.format('YYYY-MM-DD') : null,
                    adults: this.$lodash.sumBy(this.persons.filter((person) => person.type === 'adult'), 'amount'),
                    children: this.persons.filter((person) => person.type === 'child').map((child) => child.birthdate),
                    order: this.order,
                    filters: [
                    this.filters.is_refundable ? 'refundable' : null,
                    this.filters.is_package ? 'package' : null,
                    ].filter(filter => filter), // Filter null values
                    property_types: this.filters.property_types,
                    property_scope: this.filters.property_scope,
                    property_stars: this.filters.property_stars,
                    ratings: this.filters.ratings,
                    price_range: this.filters.price_range.map((range) => range.join(',')),
                    page: parseInt(this.currentPage, 10) || 1,
                };

                // Prevent request if it's identical with the last one
                if (JSON.stringify(params) === this.lastSearch) {
                    return;
                }

                // Remember last params
                this.lastSearch = JSON.stringify(params)

                // Cancel previous search
                if (this.cancelSource !== null) {
                    this.cancelSource.cancel()
                }

                // Create cancel token
                const CancelToken = axios.CancelToken
                this.cancelSource = CancelToken.source()

                this.isLoading = true

                axios.post(route('api.frontend.search'), params, {
                    cancelToken: this.cancelSource.token,
                }).then(function (response) {
                    // Redirect to search result page
                    self.$window.location.href = self.$window.route('frontend.search.show', {
                        search: response.data.data.token,
                    })
                }).catch(function (error) {
                    // console.log(error);
                    self.isLoading = false
                });
            },

            selectRegion(region) {
                this.handleChangeLocation(region)

                this.search()

                var self = this
                setTimeout(() => {
                    self.scrollTop()
                }, 300)
            },
            selectPropertyType(propertyType) {
                // this.togglePropertyType(propertyType)

                this.search()

                var self = this
                setTimeout(() => {
                    self.scrollTop()
                }, 300)
            },
            selectSearch(search) {
                this.$window.location.href = this.$window.route('frontend.search.show', {
                    search: search.token,
                })
            },

            // Copy link
            copyLink() {
                this.$window.copy('www.watado.de/suchen/' + this.currentSearch.token)
                this.isCopied = true

                var self = this
                setTimeout(() => {
                    self.isCopied = false
                }, 2000)
            },
        },
        watch: {}
    }
</script>
